import React from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import constructPagination from "components/Global/ReactTable/Pagination/utils/construct-page-numbers";
import { Div } from "components/Base";

const Pagination = ({ canNext, canPrevious, page, pages, onPageChange }) => {
  const renderPageNumber = number => {
    if (typeof number !== "number") {
      return <Div className={css.ellipsis}>{number}</Div>;
    }
    return (
      <Div
        onClick={() => onPageChange(number - 1)}
        className={number === page + 1 ? css.pageActive : css.page}
      >
        {number}
      </Div>
    );
  };

  if (pages <= 1) {
    return <Div />;
  }

  return (
    <Div className={css.container}>
      {canPrevious ? (
        <Div onClick={() => onPageChange(page - 1)} className={css.button}>
          <i className="material-icons">keyboard_arrow_left</i>
        </Div>
      ) : (
        ""
      )}
      <Div className={css.pageGroup}>
        {constructPagination({ pages, page }).map(number =>
          renderPageNumber(number)
        )}
      </Div>
      {canNext ? (
        <Div onClick={() => onPageChange(page + 1)} className={css.button}>
          <i className="material-icons">keyboard_arrow_right</i>
        </Div>
      ) : (
        ""
      )}
    </Div>
  );
};

export default CSSModules(Pagination, css);
